<template>
  <FormItem :label="label" :required="!!required">
    <Input
      type="textarea"
      v-model="_value"
      :disabled="!editable"
       :placeholder="config?.placeholder || '请输入'"
      style="width:100%"
      :rows="_config.rows || 4" />
  </FormItem>
</template>

<script>
import defaultValueMixin from '../mixins/default-value';
import valueDefMixin from '../mixins/value-def';
export default {
  mixins: [defaultValueMixin, valueDefMixin],
  methods: {
    getValueDef() {
      return this.valueDefString();
    },
  },
  cname: '长文本输入',
  corder: 20,
  icon: 'changwenbenxiangsi',
  props: ['value', 'label', 'required', 'config', 'editable'],
  computed: {
    _value: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit('input', v);
      },
    },
    _config() {
      return this.config || {};
    },
  },
  initModel(e) {
    if (!e.config) {
      e.config = {
        options: [],
        simple: true,
      };
    } else {
      e.config = {
        options: e.config.options || [],
        simple: true,
      };
    }
  },
  properties: [
    {
      label: '字数限制',
      key: 'maxlen',
      control: 'Text',
    },
    {
      label: '宽度',
      key: 'width',
      control: 'Text',
    },
    {
      label: '行数',
      key: 'rows',
      control: 'Text',
      option: {
        number: true,
      },
    },
    {
      label: '提示文字',
      key: 'placeholder',
      control: 'Text',
    },
    {
    label: '预设输入',
    key: 'options',
    control: 'SelectOption',
  }, {
    label: '简易选项',
    key: 'simple',
    control: 'Check',
  },

  ],
};
</script>

<style lang="scss" scoped>

</style>
